var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B7CC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.856 6.855a.643.643 0 0 0-.643.643v7.715c0 1.42 1.15 2.57 2.57 2.571h6.43c.98 0 1.656-.423 2.064-.99a2.796 2.796 0 0 0 .507-1.581.643.643 0 0 0-.643-.643h-1.928V7.498a.643.643 0 0 0-.643-.643H6.855Zm3.857 7.715h3.214V8.14H7.498v7.072c0 .71.576 1.285 1.286 1.285h.001c.22 0 .56-.07.829-.264.236-.17.456-.46.456-1.021 0-.355.288-.643.643-.643Zm.34 1.928h4.16c.562 0 .85-.22 1.02-.456.044-.06.08-.122.112-.187h-5.056a2.448 2.448 0 0 1-.236.643ZM8.784 10.07c0-.355.288-.643.643-.643h2.571a.643.643 0 0 1 0 1.286H9.427a.643.643 0 0 1-.643-.643Zm.643 1.285a.643.643 0 1 0 0 1.286h2.571a.643.643 0 0 0 0-1.286H9.427Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B7CC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.303 7.258A4.9 4.9 0 1 0 16.966 12a.7.7 0 1 1 1.4 0 6.3 6.3 0 1 1-4.71-6.096.7.7 0 0 1-.353 1.355Zm2.963.541a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Zm.7 2.8a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z"
  })));
};
export default SvgInProgress;